// client/src/components/admin/DashboardStats.jsx
import { Box, Paper, Typography, Stack } from '@mui/material';
import {
  Person,
  Assignment,
  AccountBalanceWallet,
  TrendingUp
} from '@mui/icons-material';

const StatCard = ({ title, value, icon, subtitle, color = "primary" }) => (
  <Paper sx={{ p: 3, flexGrow: 1, minWidth: '200px' }}>
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box sx={{ color, fontSize: '2.5rem' }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="h4" component="div" fontWeight="700">
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="success.main">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Stack>
  </Paper>
);

export default function DashboardStats() {
  // TODO: Replace with real data from API
  const stats = {
    totalUsers: '12,487',
    pendingTasks: '47',
    platformVolume: '£86,501',
    completionRate: '92%'
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 4 }}>
      <StatCard
        title="Total Users"
        value={stats.totalUsers}
        icon={<Person />}
        subtitle="+124 this week"
      />
      <StatCard
        title="Tasks for Review"
        value={stats.pendingTasks}
        icon={<Assignment />}
        color="warning"
        subtitle="Urgent: 12"
      />
      <StatCard
        title="Platform Volume"
        value={stats.platformVolume}
        icon={<AccountBalanceWallet />}
        subtitle="+£5,201 this week"
      />
      <StatCard
        title="Completion Rate"
        value={stats.completionRate}
        icon={<TrendingUp />}
        color="success"
      />
    </Box>
  );
}